import { z } from 'zod';

export const UserRole = z.enum(['member', 'owner']);
export type UserRole = z.infer<typeof UserRole>;
